import { Popover } from 'antd';
import AppResult from 'components/appResults';
import HelpPopover from 'components/help';
import * as appRoutes from "config/routes.config";
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Cours } from "../../../../assets/images/app/Cours.svg";
import { ReactComponent as Exo } from "../../../../assets/images/app/Exercices.svg";
import { ReactComponent as Quiz } from "../../../../assets/images/app/Quiz.svg";
import './contributions.css';

interface StatsData {
    mesCours: number;
    mesQuizz: number;
    mesExercice: number;
    cours: number;
    quizz: number;
    exercice: number;
}

interface StatCardProps {
    icon: React.ReactNode;
    label: string;
    value: number;
}

const StatCard: React.FC<StatCardProps> = ({ icon, label, value }) => (
    <div className="stat-card">
        <div className="stat-icon">{icon}</div>
        <div className="stat-content">
            <p className="stat-label">{label}</p>
            <p className="stat-value">{value.toLocaleString('fr-FR')}</p>
        </div>
    </div>
);

interface ContentStatsProps {
    data: StatsData;
}

const ContentStats: React.FC<ContentStatsProps> = ({ data }) => {

    const navigate = useNavigate();
    const [visibleOptions, setVisibleOptions] = useState(false);
    const popoverReportRef = useRef<HTMLDivElement>(null);

    const content = (
        <div onClick={(e) => e.stopPropagation()}>
            <div onClick={() => navigate(appRoutes.TEACHER_CREATE__COURS)} className="contentButtonContribution">Créer un cours</div>
            <div onClick={() => navigate(appRoutes.TEACHER_CREATE__QUIZ)} className="contentButtonContribution">Créer un quiz</div>
            <div onClick={() => navigate(appRoutes.TEACHER_CREATE__EXO)} className="contentButtonContribution">Créer un exercice</div>
        </div>
    );

    const handleClickOutside = (event: MouseEvent) => {
        setTimeout(() => {
            if (popoverReportRef.current && !popoverReportRef.current.contains(event.target as Node)) {
                setVisibleOptions(false);
            }
        }, 200);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [visibleOptions]);

    return (
        <div className="content-stats">
            {/* Available Content Section */}
            <section className="stats-section">
                <div className="section-header">
                    <div className="section-title-help">
                        <h2 className="section-title">Contenu disponible</h2>
                        <span style={{ marginTop: "2px" }}>
                            <HelpPopover id={"dashboard_mon_contenu"} />
                        </span>
                    </div>

                    <Popover
                        visible={visibleOptions}
                        placement="left"
                        content={content}
                        trigger="click"
                        className="customPopoverContribution"
                    >
                        <div ref={popoverReportRef} className="optionButtonContribution" onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions) }}>
                            + Ajouter une contribution
                        </div>
                    </Popover>
                </div>

                <div className="stats-grid">
                    <StatCard
                        icon={<Cours height={40} strokeWidth={1.5} />}
                        label="Nombre de cours"
                        value={data.cours}
                    />
                    <StatCard
                        icon={<Quiz height={40} strokeWidth={1.5} />}
                        label="Nombre de quizz"
                        value={data.quizz}
                    />
                    <StatCard
                        icon={<Exo height={40} strokeWidth={1.5} />}
                        label="Nombre d'exercices"
                        value={data.exercice}
                    />
                </div>
            </section>

            {/* My Contribution Section */}
            <section className="stats-section">
                <div className="section-header">
                    <div className="section-title-help">
                        <h2 className="section-title">Ma contribution</h2>
                        <span style={{ marginTop: "2px" }}>
                            <HelpPopover id={"dashboard_mes_publications"} />
                        </span>
                    </div>
                </div>

                <div className="stats-grid">
                    <StatCard
                        icon={<Cours height={40} strokeWidth={1.5} />}
                        label="Nombre de cours"
                        value={data.mesCours}
                    />
                    <StatCard
                        icon={<Quiz height={40} strokeWidth={1.5} />}
                        label="Nombre de quizz"
                        value={data.mesQuizz}
                    />
                    <StatCard
                        icon={<Exo height={40} strokeWidth={1.5} />}
                        label="Nombre d'exercices"
                        value={data.mesExercice}
                    />
                </div>
            </section>

            {/* Albert Sad App Result */}
            {data.mesCours === 0 && data.mesQuizz === 0 && data.mesExercice === 0 && <section className='albert-app-result'>
                <span>Aucune contribution</span>
                <span>{"Gagne des coins en participant à la rédaction du contenu des cours, quiz et exercices !"}</span>
                <AppResult status={'404'} title={""} />
            </section>}

            {(data.mesCours > 0 || data.mesQuizz > 0 || data.mesExercice > 0) && <section className='albert-app-result'>
                <span>Excellent mon ami !</span>
                <span>{"Bravo, tu peux faire mieux en contribuant plus !"}</span>
                <AppResult status={'success'} title={""} />
            </section>}
        </div>
    );
};

export default ContentStats;